import templates from "bundle-text:../../templates/ts-flavors.html";
import { appUtils } from "..";
import { AppBase } from "../appBase";
import { app } from '../appFlavors';
import { TypeDataProduct } from "../data";
import { LangsEvents } from "../data/langs";
import Slider from "./slider";

export default class PgFlavors {
    private _templates: { [tag: string]: string; };
    private _contCat: HTMLElement;
    private _contProduct: HTMLElement;
    private _filters = {
        catIds: [],
    };
    private _domCatAll: HTMLElement;
    private _noDataElm: HTMLInputElement;
    private _txtSearch: HTMLInputElement;
    private _sliderCategory: Slider;
    private _loading: boolean;
    private _prevSearch: string;

    constructor() {
        this._templates = appUtils.tagsToStrMap(templates);
        this._contCat = document.querySelector(".product-cat");
        this._contProduct = document.querySelector(".product-list");
        this._noDataElm = document.querySelector(".no-data");

        (this._txtSearch = document.querySelector(".form-input"))
            .addEventListener("keydown", (e) => this._onTextSearch(e));
        this._txtSearch.value = "";

        document.querySelector<HTMLButtonElement>(".form-input + button")
            .addEventListener("click", () => { this._listProducts(); })


        this._domCatAll = appUtils.stringToHTML(this._templates.category.replace("{title}", app.langs.lang.customs.all)
            .replace("{subtext}", app.langs.lang.customs.all_subtext));
        this._domCatAll.addEventListener("click", e => this._onCatClick(e));
        this._contCat.appendChild(this._domCatAll);
        this._createFilterDom(this._contCat, app.products.data.categories,
            app.langs.lang.categories, "category", this._onCatClick);

        this._sliderCategory = new Slider(document.querySelector(".product-cat-wrap"));

        app.langs.on(LangsEvents.Changed, this._onLangChange.bind(this));

        if (app.header.searchParams.get("filter_cat")) {
            this._filters.catIds = app.header.searchParams.get("filter_cat").split(",");
        }
        this._listProducts(true);
        appUtils.dataHrefToHref(this._contProduct);
    }

    private _onTextSearch(e: KeyboardEvent) {
        if (e.key == "Enter"/*  && this._prevSearch != this._txtSearch.value */)
            this._listProducts();
    }

    private _onCatClick(e: Event) {
        if (this._loading)
            return;

        const id = (e.currentTarget as HTMLElement).dataset["id"],
            indx = this._filters.catIds.indexOf(id);
        if (id == null) {
            this._filters.catIds = [];
        } else {
            if (indx > -1)
                this._filters.catIds.splice(indx, 1);
            else
                this._filters.catIds.push(id);
        }

        this._listProducts();
    }

    private _onLangChange() {
        this._contCat.querySelectorAll<HTMLElement>("[data-lang-text]").forEach(item => {
            if (item.parentElement.parentElement.dataset["id"])
                item.innerHTML = app.langs.lang.categories[item.parentElement.parentElement.dataset["id"]][item.dataset['langText']];
            else if (item.dataset['langText'] == "title")
                item.innerHTML = app.langs.lang.customs.all;
            else if (item.dataset['langText'] == "subtext")
                item.innerHTML = app.langs.lang.customs.all_subtext;
        });

        this._contProduct.querySelectorAll<HTMLElement>("[data-lang-text]").forEach(item => {
            item.textContent = app.langs.lang.products[item.parentElement.dataset["id"]].title;
        });
    }

    private _createFilterDom(cont: HTMLElement, listObj: object, langSec: object, templId: string, clickFunc: Function) {
        let dom: HTMLElement;
        for (let k in listObj) {
            dom = appUtils.stringToHTML(this._templates[templId].replace("{title}", langSec[k].title)
                .replace("{subtext}", langSec[k].subtext));
            dom.dataset["id"] = k;

            if (listObj[k].color)
                (dom.firstElementChild as HTMLButtonElement).style.setProperty("--border-color", listObj[k].color);

            dom.addEventListener("click", clickFunc.bind(this));
            cont.appendChild(dom);
        }
    }

    private _setFilterDomSelection(arr: string[], elm: HTMLElement) {
        for (let i = 0, child: HTMLElement; i < elm.children.length; i++) {
            (child = elm.children[i] as HTMLElement).firstElementChild.classList.remove("selected");
            if (arr.includes(child.dataset["id"])) child.firstElementChild.classList.add("selected");
        }
    }

    private _listProducts(noWait: boolean = false) {
        if (this._loading)
            return;

        this._prevSearch = this._txtSearch.value;
        const search = this._txtSearch.value.toLocaleLowerCase(app.langs.currentId),
            searchKeywordAnd = search.split(/\+/),
            searchKeywordOr = search.split(/,|\s/),
            searchKeywordNeedCount = searchKeywordAnd.length > searchKeywordOr.length ? searchKeywordAnd.length : 1;

        const processData = () => {
            this._setFilterDomSelection(this._filters.catIds, this._contCat);

            app.header.setSearchParam("filter_cat", this._filters.catIds.join(","));

            if (this._filters.catIds.length)
                this._domCatAll.firstElementChild.classList.remove("selected");
            else
                this._domCatAll.firstElementChild.classList.add("selected");

            let item: TypeDataProduct, elm: HTMLElement, hasText: boolean, hasCategory: boolean;
            let visibleItemCount = 0;
            for (let i = 0, si; i < app.products.data.products.length; i++) {
                item = app.products.data.products[i];
                elm = this._contProduct.querySelector<HTMLElement>("[data-id='" + item.id + "']");

                if (!elm) {
                    elm = appUtils.stringToHTML(this._templates.product
                        .replace("{catid}", item.categoryId)
                        .replace(/\{id\}/g, item.id.toString())
                        .replace("{title}", app.langs.lang.products[item.id].title)
                    );
                    elm.dataset["id"] = item.id.toString();
                    this._contProduct.appendChild(elm);
                }

                hasCategory = this._filters.catIds.length == 0 ? true : this._filters.catIds.includes(item.categoryId);

                hasText = true;
                if (search.length) {
                    const title = app.langs.lang.products[item.id].title.toLocaleLowerCase(app.langs.currentId),
                        ingredients = item.ingredients.map(v =>
                            app.langs.lang.ingredients[v.id].title.toLocaleLowerCase(app.langs.currentId));

                    let foundCount: number = 0;

                    if (searchKeywordAnd.length > searchKeywordOr.length) {
                        for (si = 0; si < searchKeywordAnd.length; si++) {
                            if (title.startsWith(searchKeywordAnd[si]) ||
                                ingredients.find(v => v.startsWith(searchKeywordAnd[si])) ||
                                item.id.toString().startsWith(searchKeywordAnd[si])) {
                                foundCount++;
                            }
                        }
                    } else {
                        for (si = 0; si < searchKeywordOr.length; si++) {
                            if (title.startsWith(searchKeywordOr[si]) ||
                                ingredients.find(v => v.startsWith(searchKeywordOr[si])) ||
                                item.id.toString().startsWith(searchKeywordOr[si])) {
                                foundCount = 1;
                                break;
                            }
                        }
                    }

                    // console.log(item.id, foundCount , searchKeywordNeedCount);
                    hasText = foundCount >= searchKeywordNeedCount;
                }

                elm.style.display = (hasCategory && hasText) ? "block" : "none";
                if (elm.style.display == "block")
                    visibleItemCount++;
            };

            this._sliderCategory.check();

            this._noDataElm.style.display = !visibleItemCount ? "block" : ""
        }

        if (noWait)
            processData();
        else {
            this._loading = true;
            app.loader.showUI(true);
            setTimeout(() => {
                processData();
                AppBase.genericAnimateDom(this._contProduct);
                this._loading = false;
                app.loader.hideUI();
            }, 250);
        }
    }
}